import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialogService, DIALOG_CONFIG} from 'ac-infra';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {CertificateComponent, changeCertificateMessage} from '../../../../components/certificates/certificate/certificate.component';
import {ConfirmationDialogComponent} from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {ConfiguratorCertificateApiService} from '../../../../services/api/settings/configurator-certificate/configurator-certificate-api.service';
import {FileSaverService} from 'ngx-filesaver';
import {MatDialog} from '@angular/material/dialog';
import {CertificateReloadDialogComponent} from '../../../../components/certificates/certificate-reload-dialog/certificate-reload-dialog.component';
import {RoutingServersSettingsApiService} from '../../../../services/api/routing-servers/routing-servers-settings-api.service';
import _ from 'lodash';
import {CertificateViewComponent} from '../../../../components/certificates/certificate-view/certificate-view.component';

@Component({
  selector: 'server-certificate-dialog',
  templateUrl: './server-certificate-dialog.component.html',
  styleUrls: ['./server-certificate-dialog.component.scss']
})
export class ServerCertificateDialogComponent implements OnInit {

  data;
  conf;
  canSubmit: boolean;
  dialogTitle: string;
  routingServerId;
  @ViewChild(CertificateComponent, {static: true}) certificateComponent;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig, private userPrivilege: UserPrivilegeService,
              private configuratorCertificateApiService: ConfiguratorCertificateApiService,
              private fileSaverService: FileSaverService,
              private dialog: MatDialog, private acDialogService: AcDialogService,
              private routingServersSettingsApiService: RoutingServersSettingsApiService) {
    this.conf = dialogConfig;
    this.routingServerId = dialogConfig.dialogData[0];
  }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.certificateComponent.resetCertificate();
  }

  onGenerateCertificateSubmit(configuratorCertificate): void {
    if (configuratorCertificate.generateType === 'privateKeyAndSelfSigned') {
      this.configuratorCertificateApiService.generateKeystore(configuratorCertificate).subscribe(data => {
        const fileType = {type: 'text/jks'};
        const blob = new Blob([data], fileType);

        this.fileSaverService.save(blob, 'arm_keystore.jks');
      });
    } else if (configuratorCertificate.generateType === 'replacePrivateKeyAndSelfSigned') {
      const confirmationMessage = `Generating a self-signed key ${changeCertificateMessage}`;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '460px',
        data: {
          message: confirmationMessage
        }
      });

      dialogRef.componentInstance.onApply.subscribe(() => {
        this.routingServersSettingsApiService.generateServerKeystore(configuratorCertificate, this.routingServerId).subscribe(
          (data) => {
            dialogRef.close();
            this.displayReloadPageDialog(data);
          });
      });
    } else if (configuratorCertificate.generateType === 'privateKeyAndCsr') {
      this.configuratorCertificateApiService.generatePrivateKeyAndCsr(configuratorCertificate).subscribe(
        data => {
          const fileType = {type: 'application/octet-stream'};
          const blob = new Blob([data], fileType);
          this.fileSaverService.save(blob, 'arm_keystore.zip');
        });
    }
  }

  onLoadCertificateSubmit(uploadCertificate): void {
    if (!_.isNil(uploadCertificate.keyStoreFile) && !_.isNil(uploadCertificate.csrfile)) {
      this.routingServersSettingsApiService.uploadServerKeystoreAndCsr(uploadCertificate,
        this.routingServerId).subscribe((data) => {
        this.displayReloadPageDialog(data);
      });
    } else if (!_.isNil(uploadCertificate.keyStoreFile)) {
      this.routingServersSettingsApiService.uploadServerKeystore(uploadCertificate,
        this.routingServerId).subscribe((data) => {
        this.displayReloadPageDialog(data);
      });
    }
  }

  onViewCurrentCertificate(): void {
    this.routingServersSettingsApiService.getCurrentServerCertificate(this.routingServerId).subscribe(data => {
      this.acDialogService.open(CertificateViewComponent, {title: 'Current Certificate',
        dialogData: data});
    });
  }

  private displayReloadPageDialog(data): void {
    const countdownInSeconds = data && data.tomcatReset ? 5 : 5;
    this.acDialogService.open(CertificateReloadDialogComponent, {
      dialogData: {
        message: `The certificate was changed successfully.
        The application will be refreshed automatically.`,
        countdownInSeconds,
        action:  () => window.location.reload()
      }});
  }

}
